import { jsx, jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { I as Icon } from "./Icon.js";
import { IconSize } from "./constants.js";
import ArrowDown from "./components/Icons/ArrowDown.js";
import ArrowUp from "./components/Icons/ArrowUp.js";
import tableStyles from "./components/Table/styles.module.scss";
import { M as ModeType } from "./Table.js";
var SortDirection = /* @__PURE__ */ ((SortDirection2) => {
  SortDirection2["asc"] = "asc";
  SortDirection2["desc"] = "desc";
  return SortDirection2;
})(SortDirection || {});
const TableHeadCell = ({
  sortable,
  onClick,
  className,
  children,
  sortDir,
  mode = ModeType.normal,
  scope = "col",
  ...rest
}) => {
  const tableHeadCellDefaultClass = classNames(tableStyles["table__head-cell"], className, {
    [tableStyles["table__head-cell--compact"]]: mode === ModeType.compact
  });
  if (!sortable && !children) {
    return /* @__PURE__ */ jsx("td", { className: tableHeadCellDefaultClass });
  }
  if (!sortable) {
    return /* @__PURE__ */ jsx("th", { scope, className: tableHeadCellDefaultClass, ...rest, children });
  }
  const sortableClasses = classNames(tableHeadCellDefaultClass, tableStyles["table__head-cell--sortable"], className);
  const renderSortIcon = () => sortDir && /* @__PURE__ */ jsx("div", { className: tableStyles["table__head-cell-sort-icon-wrapper"], children: /* @__PURE__ */ jsx(Icon, { svgIcon: sortDir == "asc" ? ArrowDown : ArrowUp, size: IconSize.XXSmall }) });
  const getSortDirection = () => {
    switch (sortDir) {
      case "asc":
        return "ascending";
      case "desc":
        return "descending";
    }
  };
  return /* @__PURE__ */ jsx("th", { scope, className: sortableClasses, "aria-sort": getSortDirection(), ...rest, children: /* @__PURE__ */ jsxs("button", { type: "button", onClick, className: tableStyles["table__sort-button"], "aria-pressed": sortDir ? !!sortDir : void 0, children: [
    renderSortIcon(),
    children
  ] }) });
};
export {
  SortDirection as S,
  TableHeadCell as T
};
//# sourceMappingURL=TableHeadCell.js.map
